module.exports = __webpack_public_path__ + "static/media/bg6.82f7c32f.png";